import type React from "react";
import { useState } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useEvents } from "@/hooks/useEvents"; // 実装が必要
import type { Event } from "@/types/event";
import { Badge } from "@/components/ui/badge";

// イベントのステータスを判定する関数
const getEventStatus = (
	event: Event,
): {
	label: string;
	variant: "default" | "secondary" | "destructive" | "outline";
} => {
	const now = new Date();
	const startDate = new Date(event.startDateTime);
	const endDate = new Date(event.endDateTime);

	if (now < startDate) {
		return {
			label: "開催予定",
			variant: "outline",
		};
	}

	if (now >= startDate && now <= endDate) {
		return {
			label: "開催中",
			variant: "default",
		};
	}

	return {
		label: "終了",
		variant: "secondary",
	};
};

const EventManagementPage: React.FC = () => {
	const [searchQuery, setSearchQuery] = useState("");
	const { events, loading, error } = useEvents(); // カスタムフックを実装する必要があります

	const filteredEvents = events?.filter((event) =>
		event.title.toLowerCase().includes(searchQuery.toLowerCase()),
	);

	return (
		<div className="space-y-6">
			<div className="flex justify-between items-center">
				<h1 className="text-3xl font-bold">イベント管理</h1>
				<div className="space-x-2">
					<Input
						className="max-w-sm"
						placeholder="イベントを検索..."
						value={searchQuery}
						onChange={(e) => setSearchQuery(e.target.value)}
					/>
					<Button>新規イベント作成</Button>
				</div>
			</div>

			{loading ? (
				<div>読み込み中...</div>
			) : error ? (
				<div className="text-red-500">エラーが発生しました: {error}</div>
			) : (
				<Table>
					<TableHeader>
						<TableRow>
							<TableHead>タイトル</TableHead>
							<TableHead>開催日時</TableHead>
							<TableHead>場所</TableHead>
							<TableHead>参加者数</TableHead>
							<TableHead>ステータス</TableHead>
							<TableHead>アクション</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{filteredEvents?.map((event) => {
							const status = getEventStatus(event);
							return (
								<TableRow key={event.id}>
									<TableCell>{event.title}</TableCell>
									<TableCell>
										{new Date(event.startDateTime).toLocaleString()}
									</TableCell>
									<TableCell>
										{event.isOnline ? "オンライン" : event.location}
									</TableCell>
									<TableCell>{event.participantCount}</TableCell>
									<TableCell>
										<Badge variant={status.variant}>{status.label}</Badge>
									</TableCell>
									<TableCell>
										<div className="space-x-2">
											<Button variant="outline" size="sm">
												編集
											</Button>
											<Button variant="outline" size="sm">
												削除
											</Button>
										</div>
									</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			)}
		</div>
	);
};

export default EventManagementPage;
